import axios from './config/axios'

const getMemberLite = (compassMemberId, compassId, pin) => {
  return axios
    .post('/api/members/member-lite', {
      compassId: compassId,
      compassMemberId: compassMemberId,
      pin: pin
    })
    .then(r => r.data)
}
export default getMemberLite